import RestAPI from '../../Common/restApi';

export default class AnalyticsApi {
  static group(properties) {
    const reqUrl = '/analytics_reporting/group';
    return RestAPI.postWithFormData(reqUrl, { properties: properties });
  }

  static getImpersonated() {
    const reqUrl = '/analytics_reporting/impersonated';
    return RestAPI.get(reqUrl);
  }

  static checkAndReportDomain() {
    const reqUrl = '/analytics_reporting/check_and_report_domain';
    return RestAPI.postWithFormData(reqUrl, {});
  }

  static trackEvent(eventName, properties) {
    const reqUrl = '/analytics_reporting/track_event';
    return RestAPI.postWithFormData(reqUrl, { event_name: eventName, properties: properties });
  }
}
